import {
  faBell,
  faBellSlash,
  faBug,
  faCog,
  faFileInvoice,
  faLifeRing,
  faSignOutAlt,
  faStar,
  faTasks
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC} from 'react';
import {Link, NavLink} from 'react-router-dom';

import {mainState} from '../AppMainState';
import {AppRoutes, logOverviewLink, projectDashboardLink, settingsLink} from '../routing/AppRoutes';
import LogoDark from '../assets/images/logo_dark.svg';
import MusculaChevron from '../assets/images/muscula_chevron.svg';
import {isTestEnv} from '../helpers/helpers';
import {redirectTo} from '../routing/browserHistory';
import {toJS} from 'mobx';
import {SidebarProjectEntry} from './SidebarProjectEntry';

export const Sidebar: FC = observer(() => {
  return <nav
    id="sidebar"
    data-tut="sidebar"
    className={
      'bg-m-gray-1 flex-col h-screen hidden px-8 pt-6 xl:flex' +
      (mainState.isShrinked ? ' sidebar-shrinked' : '')
    }
  >
    <div className="mb-4" id="muscula-brand" style={{}}>
      <a href="https://www.muscula.com">
        {!mainState.isShrinked && <img src={LogoDark} alt="Muscula" />}
        {mainState.isShrinked && <img src={MusculaChevron} alt="Muscula" />}
      </a>
    </div>

    <ul>
      <li className="hover:bg-m-gray-3">
        <NavLink
          to={AppRoutes.Starred}
          className="flex items-center justify-between"
        >
          <div className="inline-block mr-auto">
            <FontAwesomeIcon className="fill-current text-m-green" icon={faStar} />
            <span className="ml-4 sidebar-label">Starred</span>
          </div>
          <span className="badge">{mainState.currentUser?.starred}</span>
        </NavLink>
      </li>
      <li className="hover:bg-m-gray-3">
        <NavLink
          to={AppRoutes.Assigned}
          className="flex items-center justify-between"
        >
          <div className="inline-block mr-auto">
            <FontAwesomeIcon className="fill-current text-m-green" icon={faTasks} />
            <span className="ml-4 sidebar-label">Assigned</span>
          </div>
          {!mainState.isShrinked && <span className="badge">{mainState.currentUser?.assigned}</span>}
        </NavLink>
      </li>
    </ul>
    <div className="bg-m-gray-1 flex-grow mb-4 mt-2 -mx-8 overflow-y-auto px-8">
      <Link data-tut="addnewproject" className="btn btn-primary my-4 w-full" to={AppRoutes.CreateProject}>
        + Add new project
      </Link>
      <ul id="projects">
        {mainState.projects &&
          mainState.projects.map((p) => <li key={'sidebarproject' + p.projectId}>
            <SidebarProjectEntry p={p} key={p.projectId} />
          </li>)}
      </ul>
    </div>

    <div id="sidebar-down-menu" className="bg-m-gray-3 -mx-8 px-8">
      <div className="flex items-center py-4">
        <FontAwesomeIcon className="fill-current text-m-gray-6" icon={faCog} />
        {!mainState.isShrinked && <NavLink to={AppRoutes.UserAccount} id="user-info" className="ml-4">
          Settings<br />
          <span className="text-xs">
                            {mainState.currentUser?.email}
                        </span>
        </NavLink>}
      </div>
      <ul id="user-tools" className="border-t border-m-gray-2 -mx-8 px-8 py-6">
        <li>
          <NavLink
            className="flex items-center"
            onClick={(e) => {
              mainState.toggleBrowserNotifications();
              e.preventDefault();
            }}
            to={AppRoutes.Dashboard}>
            <FontAwesomeIcon className="w-4 fill-current text-m-gray-6"
                             icon={mainState.browserNotifications ? faBellSlash : faBell} />
            <span
              className="ml-4 sidebar-label">{mainState.browserNotifications ? 'Disable browser notifications' : 'Enable browser notifications'}</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            className="flex items-center"
            to={AppRoutes.Payments}
          >
            <FontAwesomeIcon className="w-4 fill-current text-m-gray-6" icon={faFileInvoice} />
            <span className="ml-4 sidebar-label">Billing</span>
          </NavLink>
        </li>
        <li>
          <NavLink
            className="flex items-center"
            to={AppRoutes.Settings}
          >
            <FontAwesomeIcon className="w-4 fill-current text-m-gray-6" icon={faCog} style={{marginTop: '1px'}} />
            <span className="ml-4 sidebar-label">Projects and logs</span>
          </NavLink>
        </li>
        {/*
            <li className="cursor-pointer flex items-center"
            >
                {!mainState.isShrinked && <React.Fragment>
                    <FontAwesomeIcon className="fill-current text-m-gray-6" icon={faCompress}/>
                    <span className="ml-4 sidebar-label">Shrink sidebar</span>
                </React.Fragment>}

                {mainState.isShrinked && <React.Fragment>
                    <FontAwesomeIcon className="fill-current text-m-gray-6" icon={faExpand} />
                    <span className="ml-4 sidebar-label">Expand sidebar</span>
                </React.Fragment>}
            </li>
             */}
        <li>
          <button className="flex items-center" onClick={() => mainState.reportProblem()}>
            <FontAwesomeIcon className="w-4 fill-current text-m-gray-6" icon={faLifeRing} />
            <span className="ml-4 sidebar-label">I need help</span>
          </button>
        </li>
        <li>
          <button className="flex items-center" onClick={() => mainState.reportProblem()}>
            <FontAwesomeIcon className="w-4 fill-current text-m-gray-6" icon={faBug} />
            <span className="ml-4 sidebar-label">Report a problem</span>
          </button>
        </li>
        {isTestEnv() && <li>
          <button className="flex items-center" onClick={() => redirectTo(AppRoutes.DevPanel)}>
            <FontAwesomeIcon className="w-4 fill-current text-m-gray-6" icon={faBug}
                             style={{marginTop: '1px'}} />
            <span className="ml-4 sidebar-label">DevPanel</span>
          </button>
        </li>}
        <li>
          <button className="flex items-center" onClick={() => mainState.signOut()}>
            <FontAwesomeIcon className="w-4 fill-current text-m-gray-6" icon={faSignOutAlt}
                             style={{marginTop: '2px'}} />
            <span className="ml-4 sidebar-label">Sign out</span>
          </button>
        </li>
      </ul>
    </div>
  </nav>;
});
